<template>
  <div>
    <el-tabs type="border-card" v-model="tabs" @tab-remove="Tabremove">
      <el-tab-pane label="兼职管理" name="lie">
        <!-- <el-collapse>
					<el-collapse-item title="筛选">
						<el-form ref="form" :model="so" label-width="80px" style="margin-left: 80px;">
							<el-form-item label="关键字">
								<el-input v-model="so.guanjianci"></el-input>
							</el-form-item>
							<el-form-item label="状态">
								<el-select v-model="so.zhuangtai" placeholder="请选择状态" style="width: 100%;">
									<el-option label="不限" value=""></el-option>
									<el-option label="上架" value="1"></el-option>
									<el-option label="下架" value="0"></el-option>
									<el-option label="待审核" value="5"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="分类">
								<Liandong :yiji.sync="so.yiji" :erji.sync="so.erji" :shu="fenleilie"></Liandong>
							</el-form-item>
							<Tijiao @click="CSH" size="medium" type="info" style="margin-left: 80px;">搜索</Tijiao>							
						</el-form>
					</el-collapse-item> 
        </el-collapse>-->


<!-- 					<el-table-column label="发布/更新时间">
						<template slot-scope="shu">
							<div>{{shu.row.shijian}}</div>
							<div>{{shu.row.gengxinshijian}}</div>
						</template>
					</el-table-column> -->

        <el-table :data="lie" style="width: 100%">
          <el-table-column prop="biaoti" label="标题" width="300"></el-table-column>
          <!-- <el-table-column prop="dizhi" label="地址" width="300"></el-table-column> -->
          <!-- <el-table-column prop="xiangxidizhi" label="详细地址" width="300"></el-table-column> -->

			<el-table-column label="地址/详细地址" width="350">
				<template slot-scope="shu">
					<div>{{shu.row.dizhi}}</div>
					<div>{{shu.row.xiangxidizhi}}</div>
				</template>
			</el-table-column>
		  
		  <el-table-column label="联系人/电话" width="250">
		  	<template slot-scope="shu">
		  		<div>{{shu.row.lianxiren}}/{{shu.row.dianhua}}</div>
		  		<!-- <div>{{shu.row.dianhua}}</div> -->
		  	</template>
		  </el-table-column>
		  
		  <el-table-column label="人数/学历" width="150">
		  	<template slot-scope="shu">
		  		<div>{{shu.row.renshu}}/{{shu.row.xueli}}</div>
		  		<!-- <div>{{shu.row.xueli}}</div> -->
		  	</template>
		  </el-table-column>
		  
		  <el-table-column label="薪资/职位" width="200">
		  			<template slot-scope="shu">
		  				<div>{{shu.row.xinzi}}/{{shu.row.zhiwei}}</div>
		  			</template>
		  </el-table-column>
		  
		  <el-table-column label="发布时间/工作时间" width="200">
			<template slot-scope="shu">
				<div>{{shu.row.shijian}}</div>
				<div>{{shu.row.gongzuoshijian}}</div>
			</template>
		  </el-table-column>
		  

		  
		  
<!--          <el-table-column prop="lianxiren" label="联系人" width="80"></el-table-column>
          <el-table-column prop="dianhua" label="电话" width="180"></el-table-column> -->
          <!-- <el-table-column prop="xinzi" label="薪资" width="180"></el-table-column> -->
          <!-- <el-table-column prop="shijian" label="发布时间" width="180"></el-table-column> -->
          <!-- <el-table-column prop="gongzuoshijian" label="工作时间" width="180"></el-table-column> -->
          <!-- <el-table-column prop="zhiweiyaoqiu" label="职位要求" width="180"></el-table-column> -->
          <!-- <el-table-column prop="fuli" label="福利" width="180"></el-table-column> -->
          <!-- <el-table-column prop="xueli" label="学历" width="180"></el-table-column> -->
          <!-- <el-table-column prop="zhiwei" label="职位" width="180"></el-table-column> -->
          <!-- <el-table-column prop="gongzhujingyan" label="工作经验" width="180"></el-table-column> -->
          <el-table-column label="操作" width="180">
            <template slot-scope="shu">
              <el-button icon="el-icon-edit-outline" size="small" @click="Bianji(shu.row)"></el-button>
              <el-button icon="el-icon-close" size="small" @click="Shandiao(shu.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="total,prev,pager,next,jumper"
          :total="zongshu"
          :page-size="so.jitiao"
          :current-page.sync="so.ye"
          @current-change="CSH"
          style="margin-top: 30px;"
        />
      </el-tab-pane>
      <!-- -->
      <el-tab-pane :label="shu.id?'编辑':'新增'" :closable="shu.id>0" name="xinzeng">
        <el-tabs>
          <el-form :model="shu">
            <el-form-item label="标题" label-width="100px">
              <el-input placeholder="请输入标题" v-model="shu.biaoti"></el-input>
            </el-form-item>
            <el-form-item label="人数" label-width="100px">
              <el-input placeholder="请输入人数" v-model="shu.renshu" />
            </el-form-item>
            <el-form-item label="联系人" label-width="100px">
              <el-input placeholder="请输入联系人" v-model="shu.lianxiren" />
            </el-form-item>
            <el-form-item label="电话" label-width="100px">
              <el-input placeholder="请输入电话号码" v-model="shu.dianhua" />
            </el-form-item>
			
			
            <el-form-item label="地址" label-width="100px">
              <el-input placeholder="请输入地址" v-model="shu.dizhi" />
            </el-form-item>
			<el-form-item label="详细地址" label-width="100px">
			  <el-input placeholder="详细地址" v-model="shu.xiangxidizhi" />
			</el-form-item>
            <el-form-item label="薪资" label-width="100px">
              <el-input placeholder="请输入薪资" v-model="shu.xinzi" />
            </el-form-item>
            <el-form-item label="学历" abel-width="100px" style="padding-left:60px">
              <!-- v-model="so.zhuangtai" -->
              <el-select placeholder="请选学历要求" v-model="shu.xueli" style="width: 60%;">
                <el-option label="不限" value></el-option>
                <el-option label="高中" value="高中"></el-option>
                <el-option label="大专" value="大专"></el-option>
                <el-option label="本科" value="本科"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="职位要求" label-width="100px">
              <el-input placeholder="请输入你的要求" v-model="shu.zhiweiyaoqiu" />
            </el-form-item>
            <el-form-item label="福利" label-width="100px">
              <el-input placeholder="请输入福利" v-model="shu.fuli" />
            </el-form-item>
            <el-form-item label="工作时间" label-width="100px">
              <el-input placeholder="请输入工作时间" v-model="shu.gongzuoshijian" />
            </el-form-item>
			<el-form-item label="工作经验" label-width="100px">
			  <el-input placeholder="工作经验" v-model="shu.gongzhujingyan" />
			</el-form-item>
			<el-form-item label="职位" label-width="100px">
			  <el-input placeholder="职位" v-model="shu.zhiwei" />
			</el-form-item>

            <el-form-item>
              <Tijiao @click="Tijiao"></Tijiao>
            </el-form-item>
          </el-form>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
let that;
export default {
  data() {
    return {
      shu: {},
      lie: [],
      tabs: "lie",
      so: {
        ye: 1,
        jitiao: 20
      },
      zongshu: 0
    };
  },
  created() {
    that = this;
    this.CSH();
  },
  methods: {
    CSH() {
      this.$post("m=zw_pige&k=jianzhi", that.so, function(s) {
        that.lie = s.shu.lie;
        that.zongshu = Number(s.shu.zongshu);
      });
    },
    Bianji(e) {
      that.shu = [];
      that.tabs = "xinzeng";
      that.shu = e;
    },
    Tabremove(e) {
      that.tabs = "lie";
      that.shu = {};
    },
    Tijiao() {
      that.$post("m=zw_pige&k=jianzhi&c=xiugai", that.shu, function(s) {
        that.$xiaoxi(s.shu);
        if (s.shi == 1) {
          that.CSH();
        }
      });
    },
    Shandiao(e) {
      that.$post("m=zw_pige&k=jianzhi&c=shanchu", { id: e.id }, function(s) {
        that.$xiaoxi(s.shu);
        if (s.shi == 1) {
          that.CSH();
        }
      });
    }
  }
};
</script>
<style scope>
.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}
.eltag {
  margin-right: 5px;
  cursor: pointer;
}

.el-table_1_column_3 .cell {
  display: flex;
}
</style>
